export default "__VITE_ASSET__id76EQwg__"